/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { CBQQuestionDTO } from "./InitCBQQuestion";

type GetAdminCBQScenarioQuestionsResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQQuestionDTO[];
};

const unwrapList = (payload: any): CBQQuestionDTO[] => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.questions)) return payload.questions;
  return [];
};

// GET /admin/cbq/scenarios/:cbqScenarioId/questions
export const GetAdminCBQScenarioQuestions = async (
  scenarioId: string
): Promise<GetAdminCBQScenarioQuestionsResponse> => {
  try {
    const response = await axios.get(
      `/admin/cbq/scenarios/${scenarioId}/questions`
    );
    return { data: unwrapList(response.data?.data ?? response.data) };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      if (error.response.status === 404) return { data: [] };
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
